import { ChangeDetectionStrategy, Component, TemplateRef, input, output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';
import { GameId } from 'src/app/shared/models/game/game-id';
import { GameInterfaceState } from 'src/app/shared/models/game/game-interface-state';
import { Match } from 'src/app/shared/types/match-type';
import type { SoloAmountDisplay } from 'src/app/features/solo/utils/solo-tiers.utils';
import { GameReplayComponent } from 'src/app/features/game/components/game-replay/game-replay.component';
import { GameScoreComponent } from 'src/app/features/game/components/game-score/game-score.component';

@Component({
  selector: 'app-header-view',
  templateUrl: './app-header-view.component.html',
  styleUrls: ['./app-header-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, GameScoreComponent, GameReplayComponent],
})
export class AppHeaderViewComponent {
  readonly showNavbar = input(false);
  readonly showGameScore = input(false);
  readonly showGameReplay = input(false);
  // The navbar comes in as a template rather than an element: the navbar is service-bound, and a
  // slot keeps this view free of it while the navbar is still created only when it shows.
  readonly navbarTemplate = input<TemplateRef<unknown>>();

  readonly gameId = input.required<GameId>();
  readonly gameScoreName = input<string>();
  readonly isLocal = input(false);
  // The game-score state: shows GameStarted while the player plays again.
  readonly displayGameInterfaceState = input.required<GameInterfaceState>();
  // The raw state, which the replay bar reads.
  readonly gameInterfaceState = input.required<GameInterfaceState>();
  readonly score = input<number>();
  readonly reward = input<{ primary: CurrencyAmountDisplay; secondary: CurrencyAmountDisplay }>();
  readonly countdown = input<number>();
  readonly match = input<Match>();
  // A Solo round's target and prize, each undefined until its attempt is known.
  readonly soloTarget = input<number>();
  readonly soloPrize = input<SoloAmountDisplay>();
  readonly roomId = input<string>();

  readonly backClickedEvent = output<void>();
  readonly closeClickedEvent = output<void>();
  readonly cheatSheetClickedEvent = output<void>();
  readonly closeReplayClickedEvent = output<void>();

  onBackClicked() {
    this.backClickedEvent.emit();
  }

  onCloseClicked() {
    this.closeClickedEvent.emit();
  }

  onCheatSheetClicked() {
    this.cheatSheetClickedEvent.emit();
  }

  onCloseReplayClicked() {
    this.closeReplayClickedEvent.emit();
  }
}
